const BATCH_DOCTOR_DATA = [
  {
    "slug": "qderma",
    "name": "Dr Shah Aaqib Aslam",
    "clinic": "Q'Derma The Skin Clinic",
    "address": "1st Floor, Building, 183, Jawahar Nagar, Srinagar, Jammu and Kashmir 190008",
    "phone": "+91 6005348879",
    "whatsappUrl": "https://wa.me/916005348879?text=Hello%2C%20I%20just%20completed%20my%20AI%20Skin%20Analysis%20and%20would%20like%20to%20consult%20with%20your%20dermatologist",
    "mapsUrl": "https://maps.app.goo.gl/o57JKR7YdDv4i7L8A",
    "photoUrl": "/assets/doctors/qderma/photo.jpg",
    "logoUrl": "/assets/doctors/qderma/logo.jpg",
    "accentColor": "#C7A65F",
    "accentColorDark": "#9B814A",
    "accentColorLight": "#D3B982"
  },
  {
    "slug": "dheeran",
    "name": "Dr. Vivin Prasanth",
    "clinic": "Dheeran Hair Transplant Clinic",
    "address": "first floor, 6.7, 4/5, Rajendra prasad street, above tulasi pharmacy, Ganapathy, Coimbatore",
    "phone": "+91 9345145978",
    "whatsappUrl": "https://wa.me/919345145978?text=Hello%2C%20I%20just%20completed%20my%20AI%20Skin%20Analysis%20and%20would%20like%20to%20consult%20with%20your%20dermatologist.",
    "mapsUrl": "https://maps.app.goo.gl/JDLaKqoG86dKfTgX8",
    "photoUrl": "/assets/doctors/dheeran/photo.jpg",
    "logoUrl": "/assets/doctors/dheeran/logo.png",
    "accentColor": "#0A3732",
    "accentColorDark": "#072A27",
    "accentColorLight": "#3F635F"
  },
  {
    "slug": "skinic",
    "name": "Dr. Vibhor Kaushal",
    "clinic": "Skinic",
    "address": "Upper Ground Floor, 33/100, Namner Rd, near Chaudhary diagnostic center, Namner, Rakabganj, Agra",
    "phone": "+91 9012118885",
    "whatsappUrl": "https://wa.me/919012118885?text=Hello%2C%20I%20just%20completed%20my%20AI%20Skin%20Analysis%20and%20would%20like%20to%20consult%20with%20your%20dermatologist.",
    "mapsUrl": "https://maps.app.goo.gl/RMZCV5xY1CHBUunv9",
    "photoUrl": "/assets/doctors/skinic/photo.jpg",
    "logoUrl": "/assets/doctors/skinic/logo.png",
    "photoObjectPosition": "center top",
    "photoZoom": 1.03,
    "analysisWaitingLogoClass": "h-24 max-w-xs mb-8 object-contain",
    "accentColor": "#B74290",
    "accentColorDark": "#8E3370",
    "accentColorLight": "#C66BA8"
  },
  {
    "slug": "cleo",
    "name": "Dr. Vaani Veggalam",
    "clinic": "Cleo Skin & Hair Clinic",
    "address": "Kukatpally Housing Board Colony, KPHB Phase 2, Kukatpally, Hyderabad, Telangana 500072",
    "phone": "+91 7416055651",
    "whatsappUrl": "https://wa.me/917416055651?text=Hello%2C%20I%20just%20completed%20my%20AI%20Skin%20Analysis%20and%20would%20like%20to%20consult%20with%20your%20dermatologist.",
    "mapsUrl": "https://maps.app.goo.gl/njyWCW78dXtWmJcE7",
    "photoUrl": "/assets/doctors/cleo/photo.jpg",
    "logoUrl": "/assets/doctors/cleo/logo.svg",
    "accentColor": "#D7B56D",
    "accentColorDark": "#A78D55",
    "accentColorLight": "#DFC58D"
  },
  {
    "slug": "dermacurethilak",
    "name": "Dr. Thilak Sundaraj",
    "clinic": "Dr. Thilak's Dermacure Skin Hair and Laser clinic",
    "address": "Backside of Saravana Bhavan Hotel, 793, 1st St, G Block, Ranganathan Garden, Anna Nagar, Chennai",
    "phone": "+91 9655223311",
    "whatsappUrl": "https://wa.me/919884104604?text=Hello%2C%20I%20just%20completed%20my%20AI%20Skin%20Analysis%20and%20would%20like%20to%20consult%20with%20your%20dermatologist.",
    "mapsUrl": "https://maps.app.goo.gl/xfVq9YQ4RJvFV2QN8",
    "photoUrl": "/assets/doctors/dermacurethilak/photo.jpg",
    "logoUrl": "/assets/doctors/dermacurethilak/logo.png",
    "photoObjectPosition": "center top",
    "photoZoom": 1,
    "accentColor": "#174021",
    "accentColorDark": "#113119",
    "accentColorLight": "#4A6A51"
  },
  {
    "slug": "hydra",
    "name": "Dr. Swetha Rahul",
    "clinic": "Hydra Dermatology",
    "address": "52, Eldams Rd, Vannia Teynampet, Venus Colony, Teynampet, Chennai",
    "phone": "+91 9884849372",
    "whatsappUrl": "https://wa.me/919884849372?text=Hello%2C%20I%20just%20completed%20my%20AI%20Skin%20Analysis%20and%20would%20like%20to%20consult%20with%20your%20dermatologist.",
    "mapsUrl": "https://maps.app.goo.gl/Nn7tLYKFGoQYbwmz7",
    "photoUrl": "/assets/doctors/hydra/photo.jpg",
    "logoUrl": "/assets/doctors/hydra/logo.jpg",
    "accentColor": "#8FD4DC",
    "accentColorDark": "#6FA5AB",
    "accentColorLight": "#A7DDE3"
  },
  {
    "slug": "skinmatics",
    "name": "Dr. Suganya Naidu",
    "clinic": "Skinmatics Clinic Hennur",
    "address": "Byreshwara Layout, Hennur Bande, HBR Layout, Bengaluru, Karnataka 560043",
    "phone": "+91 9980877731",
    "whatsappUrl": "https://wa.me/919980877731?text=Hello%2C%20I%20just%20completed%20my%20AI%20Skin%20Analysis%20and%20would%20like%20to%20consult%20with%20your%20dermatologist.",
    "mapsUrl": "https://maps.app.goo.gl/b9Hj49q4b7nYQsUWA",
    "photoUrl": "/assets/doctors/skinmatics/photo.jpg",
    "logoUrl": "/assets/doctors/skinmatics/logo.jpg",
    "accentColor": "#69603F",
    "accentColorDark": "#514A31",
    "accentColorLight": "#8A8269"
  },
  {
    "slug": "twachaa",
    "name": "Dr. Shivank Shrivastava",
    "clinic": "Twachaa skin hair and laser clinic",
    "address": "C-2/4, 1st Floor, Mahakal Vanijyik Kendra, near Sanwariya Sandwich, Nanakheda, Ujjain",
    "phone": "+91 7440380229",
    "whatsappUrl": "https://wa.me/917440380229?text=Hello%2C%20I%20just%20completed%20my%20AI%20Skin%20Analysis%20and%20would%20like%20to%20cons",
    "mapsUrl": "https://maps.app.goo.gl/BxfMqL8MuVNqi4dB9",
    "photoUrl": "/assets/doctors/twachaa/photo.jpg",
    "logoUrl": "/assets/doctors/twachaa/logo.jpg",
    "accentColor": "#D7FF77",
    "accentColorDark": "#A7C65C",
    "accentColorLight": "#DFFF94"
  },
  {
    "slug": "urmil",
    "name": "Dr. Samkit Shah",
    "clinic": "Urmil Skin Clinic",
    "address": "GIDC Madhu Apartment, Chharawada Rd, Vapi, Gujarat 396191",
    "phone": "+91 8000540837",
    "whatsappUrl": "https://wa.me/918000540837?text=Hello%2C%20I%20just%20completed%20my%20AI%20Skin%20Analysis%20and%20would%20like%20to%20consult%20with%20your%20dermatologist.",
    "mapsUrl": "https://maps.app.goo.gl/M7WvVLGMPn3cmXpp8",
    "photoUrl": "/assets/doctors/urmil/photo.jpg",
    "logoUrl": "/assets/doctors/urmil/logo.svg",
    "accentColor": "#FBD9CA",
    "accentColorDark": "#C3A99D",
    "accentColorLight": "#FBE1D5"
  },
  {
    "slug": "reshmas",
    "name": "Dr. Reshma Ajith",
    "clinic": "Dr. Reshma\u00e2\u20ac\u2122s Skin-Hair-Laser Clinic",
    "address": "Puzhathi Housing Colony, Kannur, Kerala 670102",
    "phone": "+91 8075969943",
    "whatsappUrl": "https://wa.me/918075969943?text=Hello%2C%20I%20just%20completed%20my%20AI%20Skin%20Analysis%20and%20would%20like%20to%20consult%20with%20your%20dermatologist.",
    "mapsUrl": "https://maps.app.goo.gl/HkCF9eiB9hFqCnsb8",
    "photoUrl": "/assets/doctors/reshmas/photo.jpg",
    "logoUrl": "/assets/doctors/reshmas/logo.png",
    "accentColor": "#0EB6AA",
    "accentColorDark": "#0A8D84",
    "accentColorLight": "#43C6BC"
  },
  {
    "slug": "rarestudio",
    "name": "Dr. Rajvee Rajshakha",
    "clinic": "RARE Aesthetic Studio",
    "address": "Dut Sai Nagar, Porbandar, Gujarat 360575",
    "phone": "+91 9692923939",
    "whatsappUrl": "https://wa.me/919692923939?text=Hello%2C%20I%20just%20completed%20my%20AI%20Skin%20Analysis%20and%20would%20like%20to%20consult%20with%20your%20dermatologist.",
    "mapsUrl": "https://maps.app.goo.gl/U3FkmeZmZYEZDCxu9",
    "photoUrl": "/assets/doctors/rarestudio/photo.jpg",
    "logoUrl": "/assets/doctors/rarestudio/logo.png",
    "accentColor": "#C5938C",
    "accentColorDark": "#99726D",
    "accentColorLight": "#D1AAA5"
  },
  {
    "slug": "radhikakopikar",
    "name": "Dr. Radhika Kopikar",
    "clinic": "Kopikar Dermatology",
    "address": "Vikhroli (E, Tagore Nagar, Vikhroli East, Mumbai, Maharashtra 400083",
    "phone": "+91 9967000000",
    "whatsappUrl": "https://wa.me/919967010034?text=Hello%2C%20I%20just%20completed%20my%20AI%20Skin%20Analysis%20and%20would%20like%20to%20consult%20with%20your%20dermatologist.",
    "mapsUrl": "https://maps.app.goo.gl/8gyE79g8rEP7p7pH6",
    "photoUrl": "/assets/doctors/radhikakopikar/photo.jpg",
    "logoUrl": "/assets/doctors/radhikakopikar/logo.svg",
    "photoObjectPosition": "center top",
    "photoZoom": 1.08,
    "accentColor": "#68C2CA",
    "accentColorDark": "#51979D",
    "accentColorLight": "#89CFD5"
  },
  {
    "slug": "punkeshkumar",
    "name": "Dr. Punkesh Kumar",
    "clinic": "Dr. Punkesh's Advance Skin Hair and Laser Clinic",
    "address": "J566+52F, 50 feet East of Dinkar Golambar, RK Ave, in front of Mittal traders, Bangali Akhara, Rajendra Nagar, Patna",
    "phone": "+91 7667445571",
    "whatsappUrl": "https://wa.me/917667445571?text=Hello%2C%20I%20just%20completed%20my%20AI%20Skin%20Analysis%20and%20would%20like%20to%20consult%20with%20your%20dermatologist.",
    "mapsUrl": "https://maps.app.goo.gl/FLwQtjAAiMjZPEgp7",
    "photoUrl": "/assets/doctors/punkeshkumar/photo.jpg",
    "logoUrl": "/assets/doctors/punkeshkumar/logo.svg",
    "photoObjectPosition": "center 30%",
    "photoZoom": 1.1,
    "accentColor": "#A27911",
    "accentColorDark": "#7E5E0D",
    "accentColorLight": "#B69645"
  },
  {
    "slug": "nirvana",
    "name": "Dr. Pratik Shivhare",
    "clinic": "Nirvana Skin & Hair Clinic",
    "address": "143/1 Dariapura, 563, near Laxmi Gate, near Trands Mall, Veerangna Nagar, Jhansi",
    "phone": "+91 9454958456",
    "whatsappUrl": "https://wa.me/919454958456?text=Hello%2C%20I%20just%20completed%20my%20AI%20Skin%20Analysis%20and%20would%20like%20to%20consult%20with%20your%20dermatologist.",
    "mapsUrl": "https://maps.app.goo.gl/WoVBHrUf1rheqAFX7",
    "photoUrl": "/assets/doctors/nirvana/photo.jpg",
    "logoUrl": "/assets/doctors/nirvana/logo.svg",
    "accentColor": "#B38A65",
    "accentColorDark": "#8B6B4E",
    "accentColorLight": "#C3A386"
  },
  {
    "slug": "swastikent",
    "name": "Dr. Poonam Jalan",
    "clinic": "Swastik Ent and skin clinic",
    "address": "128, Sarat Bose Rd, Dover Terrace, Ballygunge, Kolkata",
    "phone": "+91 8697509910",
    "whatsappUrl": "https://wa.me/918697509910?text=Hello%2C%20I%20just%20completed%20my%20AI%20Skin%20Analysis%20and%20would%20like%20to%20consult%",
    "mapsUrl": "https://maps.app.goo.gl/LjNgUPzJBm3Jj2D69",
    "photoUrl": "/assets/doctors/swastikent/photo.jpeg",
    "logoUrl": "/assets/doctors/swastikent/logo.png",
    "accentColor": "#F24B5C",
    "accentColorDark": "#BC3A47",
    "accentColorLight": "#F4727F"
  },
  {
    "slug": "dermaqure",
    "name": "Dr. Pawan Kumar",
    "clinic": "Dermaqure skin and cosmetology clinic",
    "address": "T. Dasarahalli, Bengaluru, Karnataka 560057",
    "phone": "+91 9742573735",
    "whatsappUrl": "https://wa.me/919742573735?text=Hello%2C%20I%20just%20completed%20my%20AI%20Skin%20Analysis%20and%20would%20like%20to%20consult%20with%20your%20dermatologist",
    "mapsUrl": "https://maps.app.goo.gl/nwoTSSkWow2RX9q56",
    "photoUrl": "/assets/doctors/dermaqure/photo.jpg",
    "logoUrl": "/assets/doctors/dermaqure/logo.png",
    "photoObjectPosition": "center top",
    "photoZoom": 1.05,
    "photoTransformOrigin": "100% top",
    "accentColor": "#FFCCCC",
    "accentColorDark": "#C69F9F",
    "accentColorLight": "#FFD7D7"
  },
  {
    "slug": "pallavi",
    "name": "Dr. Pallavi",
    "clinic": "Dr. Pallawi's Skin and Hair Clinic",
    "address": "Bistupur, Jamshedpur, Jharkhand 831001",
    "phone": "+91 7044202141",
    "whatsappUrl": "https://wa.me/917044202141?text=Hello%2C%20I%20just%20completed%20my%20AI%20Skin%20Analysis%20and%20would%20like%20to%20consult%20with%20your%20dermatologist.",
    "mapsUrl": "https://maps.app.goo.gl/HmCvo6y9eyTALWHH8",
    "photoUrl": "/assets/doctors/pallavi/photo.jpg",
    "logoUrl": "/assets/doctors/pallavi/logo.svg",
    "accentColor": "#0D4A4A",
    "accentColorDark": "#0A3939",
    "accentColorLight": "#427171"
  },
  {
    "slug": "skinethics",
    "name": "Dr. Pallavi Ahire",
    "clinic": "SkinEthics",
    "address": "Baner, Pune, Maharashtra 411069",
    "phone": "+91 9028291234",
    "whatsappUrl": "https://wa.me/919028291234?text=Hello%2C%20I%20just%20completed%20my%20AI%20Skin%20Analysis%20and%20would%20like%20to%20consult%20with%20your%20dermatologist.",
    "mapsUrl": "https://maps.app.goo.gl/BAwZS8vBHBF1M5XN8",
    "photoUrl": "/assets/doctors/skinethics/photo.jpg",
    "logoUrl": "/assets/doctors/skinethics/logo.svg",
    "photoObjectPosition": "center top",
    "photoZoom": 1.05,
    "accentColor": "#F29389",
    "accentColorDark": "#BC726A",
    "accentColorLight": "#F4AAA2"
  },
  {
    "slug": "pragnaclinic",
    "name": "Dr. Padmavathi S",
    "clinic": "pragna skin clinc",
    "address": "Punjagutta, Hyderabad, Telangana 500082",
    "phone": "+91 9848367000",
    "whatsappUrl": "https://wa.me/919848367000?text=Hello%2C%20I%20just%20completed%20my%20AI%20Skin%20Analysis%20and%20would%20like%20to%20consult%20with%20your%20dermatologist",
    "mapsUrl": "https://maps.app.goo.gl/EtZQdashiU9hcpdc8",
    "photoUrl": "/assets/doctors/pragnaclinic/photo.jpg",
    "logoUrl": "/assets/doctors/pragnaclinic/logo.svg",
    "accentColor": "#933634",
    "accentColorDark": "#722A28",
    "accentColorLight": "#AA6260"
  },
  {
    "slug": "radiance",
    "name": "Dr. Nitin Barde",
    "clinic": "radiance clinic",
    "address": "2nd Floor, Panchavati Tower, Wardha Rd, beside Hitvada Press & Shatau Hospital, near Dhantoli, Dhantoli, Nagpur",
    "phone": "+91 9822176677",
    "whatsappUrl": "https://wa.me/919822176677?text=Hello%2C%20I%20just%20completed%20my%20AI%20Skin%20Analysis%20and%20would%20like%20to%20consult%20with%20your%20dermatologist.",
    "mapsUrl": "https://maps.app.goo.gl/TUysgSkjq9v1cL6r7",
    "photoUrl": "/assets/doctors/radiance/photo.jpg",
    "logoUrl": "/assets/doctors/radiance/logo.svg",
    "accentColor": "#FF9900",
    "accentColorDark": "#C67700",
    "accentColorLight": "#FFAF38"
  },
  {
    "slug": "sparsh",
    "name": "Dr. Nikhil Kajale",
    "clinic": "Sparsh Skin Clinic",
    "address": "near City Centre Mall Signal, Nashik, Maharashtra 422002",
    "phone": "+91 9619841393",
    "whatsappUrl": "https://wa.me/919619841393?text=Hello%2C%20I%20just%20completed%20my%20AI%20Skin%20Analysis%20and%20would%20like%20to%20consult%20with%20your%20dermatologist.",
    "mapsUrl": "https://maps.app.goo.gl/GkUjdp771oVP17m89",
    "photoUrl": "/assets/doctors/sparsh/photo.jpg",
    "logoUrl": "/assets/doctors/sparsh/logo.png",
    "accentColor": "#2C4B98",
    "accentColorDark": "#223A76",
    "accentColorLight": "#5A72AE"
  },
  {
    "slug": "nehashukla",
    "name": "Dr. Neha Shukla",
    "clinic": "",
    "address": "near ICICI Bank, Sargasan, Gandhinagar, Gujarat 382423",
    "phone": "+91 9601565327",
    "whatsappUrl": "https://wa.me/919601565327?text=Hello%2C%20I%20just%20completed%20my%20AI%20Skin%20Analysis%20and%20would%20like%20to%20consult%20with%20your%20dermatologist.",
    "mapsUrl": "https://maps.app.goo.gl/bqrniB2g7fvwX9cdA",
    "photoUrl": "/assets/doctors/nehashukla/photo.png",
    "logoUrl": "/assets/doctors/nehashukla/logo.svg",
    "photoObjectPosition": "center top",
    "photoZoom": 1.15,
    "photoTransformOrigin": "center top",
    "accentColor": "#4378DF",
    "accentColorDark": "#345DAD",
    "accentColorLight": "#6C95E6"
  },
  {
    "slug": "skinbliss",
    "name": "Dr. Neha Rani",
    "clinic": "Skin Bliss Clinic",
    "address": "Bariatu, Ranchi, Jharkhand 834009",
    "phone": "+91 9955005277",
    "whatsappUrl": "https://wa.me/919955005277?text=Hello%2C%20I%20just%20completed%20my%20AI%20Skin%20Analysis%20and%20would%20like%20to%20consult%20with%20your%20dermatologist.",
    "mapsUrl": "https://maps.app.goo.gl/kKqkJsrXFgbKFpHB6",
    "photoUrl": "/assets/doctors/skinbliss/photo.jpg",
    "logoUrl": "/assets/doctors/skinbliss/logo.svg",
    "accentColor": "#67B439",
    "accentColorDark": "#508C2C",
    "accentColorLight": "#88C464"
  },
  {
    "slug": "monikapatidar",
    "name": "Dr. Monika Patidar",
    "clinic": "Dr Monika's Skin, Laser, Hair & Cosmetology",
    "address": "4, Annapurna Rd, Rajendra Nagar, Prabhu Nagar, Indore",
    "phone": "+91 8370025121",
    "whatsappUrl": "https://wa.me/918370025121?text=Hello%2C%20I%20just%20completed%20my%20AI%20Skin%20Analysis%20and%20would%20like%20to%20consult%20with%20your%20dermatologist.",
    "mapsUrl": "https://maps.app.goo.gl/intiR23mxBQEHZXX8",
    "photoUrl": "/assets/doctors/monikapatidar/photo.jpg",
    "logoUrl": "/assets/doctors/monikapatidar/logo.png",
    "accentColor": "#A5CC37",
    "accentColorDark": "#809F2A",
    "accentColorLight": "#B8D763"
  },
  {
    "slug": "anugraha",
    "name": "Dr. Monica Bambroo",
    "clinic": "Anugraha Skin, laser, hair & urology clinic",
    "address": "764, Opp ATS Appartments, near Gayatri Nawal Hospital, Niti Khand I, Indirapuram, Ghaziabad",
    "phone": "+91 8076846266",
    "whatsappUrl": "https://wa.me/918076846266?text=Hello%2C%20I%20just%20completed%20my%20AI%20Skin%20Analysis%20and%20would%20like%20to%20consult%20with%20your%20dermatologist.",
    "mapsUrl": "https://maps.app.goo.gl/GnoYLpuRp7epFb2RA",
    "photoUrl": "/assets/doctors/anugraha/photo.jpg",
    "logoUrl": "/assets/doctors/anugraha/logo.svg",
    "photoObjectPosition": "center top",
    "photoZoom": 1.05,
    "accentColor": "#925624",
    "accentColorDark": "#71431C",
    "accentColorLight": "#A97B54"
  },
  {
    "slug": "cuticare",
    "name": "Dr. Mir Mubashir Ali",
    "clinic": "Cuticare Centre",
    "address": "\u00c2 Toli Chowki, Hyderabad, Telangana 500008",
    "phone": "+91 6302535348",
    "whatsappUrl": "https://wa.me/916302535348?text=Hello%2C%20I%20just%20completed%20my%20AI%20Skin%20Analysis%20and%20would%20like%20to%20consult%20with%20your%20dermatologist",
    "mapsUrl": "https://maps.app.goo.gl/6BwQzMVYV4GtSfJy7",
    "photoUrl": "/assets/doctors/cuticare/photo.jpg",
    "logoUrl": "/assets/doctors/cuticare/logo.jpg",
    "photoObjectPosition": "center 30%",
    "photoZoom": 1.06,
    "accentColor": "#0CA0C1",
    "accentColorDark": "#097C96",
    "accentColorLight": "#41B4CE"
  },
  {
    "slug": "hope",
    "name": "Dr. Jagjeet Sethi",
    "clinic": "Hope Clinic",
    "address": "Pine Mount Ridge(Opp Pine Mount School),Barik,Shillong 793001",
    "phone": "+91 8257000001",
    "whatsappUrl": "https://wa.me/918257000001?text=Hello%2C%20I%20just%20completed%20my%20AI%20Skin%20Analysis%20and%20would%20like%20to%20consult%20with%20your%20dermatologist.",
    "mapsUrl": "https://maps.app.goo.gl/yRy6bA23VqUxo6YE8",
    "photoUrl": "/assets/doctors/hope/photo.jpg",
    "logoUrl": "/assets/doctors/hope/logo.png",
    "accentColor": "#264174",
    "accentColorDark": "#1D325A",
    "accentColorLight": "#556A92"
  },
  {
    "slug": "jagdishsakhiya",
    "name": "Dr. Jagdish Sakhiya",
    "clinic": "Sakhiya Skin Clinic",
    "address": "Infinity Tower, 1101, Lal Darwaja Station Rd, near Ayurvedic college, Suryapur Gate, Varachha, Surat, Gujarat 395008",
    "phone": "+91 9875147554",
    "whatsappUrl": "https://wa.me/919875147554?text=Hello%2C%20I%20just%20completed%20my%20AI%20Skin%20Analysis%20and%20would%20like%20to%20consult%20with%20your%20dermatologist.",
    "mapsUrl": "https://maps.app.goo.gl/jsKPHviEfwJPPkMUA",
    "photoUrl": "/assets/doctors/jagdishsakhiya/photo.png",
    "logoUrl": "/assets/doctors/jagdishsakhiya/logo.svg",
    "accentColor": "#0F766E",
    "accentColorDark": "#0B5C55",
    "accentColorLight": "#43948D"
  },
  {
    "slug": "irshadali",
    "name": "Dr. Irshad Ali",
    "clinic": "Dr. Irshad Ali's Skin Care Centre & Hair Transplantation centre",
    "address": "Highway, Kunnappally, Kerala 679322",
    "phone": "+91 9947549050",
    "whatsappUrl": "https://wa.me/919947549050?text=Hello%2C%20I%20just%20completed%20my%20AI%20Skin%20Analysis%20and%20would%20like%20to%20consult%20with%20your%20dermatologist.",
    "mapsUrl": "https://maps.app.goo.gl/CVnuykRfL98rMk5M7",
    "photoUrl": "/assets/doctors/irshadali/photo.jpg",
    "logoUrl": "/assets/doctors/irshadali/logo.svg",
    "photoObjectPosition": "center 20%",
    "photoZoom": 1.08,
    "accentColor": "#0F766E",
    "accentColorDark": "#0B5C55",
    "accentColorLight": "#43948D"
  },
  {
    "slug": "indyu",
    "name": "Dr. Indu Balan",
    "clinic": "Indyu Skin Care Clinic",
    "address": "\u00c2 Kochi, Ernakulam, Kerala 682026",
    "phone": "+91 9497115544",
    "whatsappUrl": "https://wa.me/919497115544?text=Hello%2C%20I%20just%20completed%20my%20AI%20Skin%20Analysis%20and%20would%20like%20to%20consult%20with%20your%20dermatologist",
    "mapsUrl": "https://maps.app.goo.gl/BAqybyasjocM4LmCA",
    "photoUrl": "/assets/doctors/indyu/photo.jpg",
    "logoUrl": "/assets/doctors/indyu/logo.svg",
    "accentColor": "#0F766E",
    "accentColorDark": "#0B5C55",
    "accentColorLight": "#43948D"
  },
  {
    "slug": "ziva",
    "name": "Dr. Haridaran Anand",
    "clinic": "Ziva skin clinic",
    "address": "No. 370, 371, Cura Health Plus, IInd Floor, NSR Road, Saibaba Colony, opposite Dominos, Coimbatore",
    "phone": "+91 9943699810",
    "whatsappUrl": "https://wa.me/919943699810?text=Hello%2C%20I%20just%20completed%20my%20AI%20Skin%20Analysis%20and%20would%20like%20to%20consult%20with%20your%20dermatologist.",
    "mapsUrl": "https://maps.app.goo.gl/U8ivgVcbBa2dCa2p6",
    "photoUrl": "/assets/doctors/ziva/photo.jpg",
    "logoUrl": "/assets/doctors/ziva/logo.png",
    "accentColor": "#ED691F",
    "accentColorDark": "#B85118",
    "accentColorLight": "#F08A50"
  },
  {
    "slug": "riha",
    "name": "Dr. Heleena Peter",
    "clinic": "Riha Skin Care",
    "address": "\u00c2 Parass La, Adoor, Kerala 691523",
    "phone": "+91 8606841723",
    "whatsappUrl": "https://wa.me/918606841723?text=Hello%2C%20I%20just%20completed%20my%20AI%20Skin%20Analysis%20and%20would%20like%20to%20consult%20with%20your%20dermatologist",
    "mapsUrl": "https://maps.app.goo.gl/fsbi6b9rSYHFSCEK7",
    "photoUrl": "/assets/doctors/riha/photo.jpg",
    "logoUrl": "/assets/doctors/riha/logo.jpg",
    "accentColor": "#83516D",
    "accentColorDark": "#663F55",
    "accentColorLight": "#9E778D"
  },
  {
    "slug": "twacha",
    "name": "Dr. H S Chauhan",
    "clinic": "Twacha Dermatology Skin Cosmetic & Laser Clinic",
    "address": "Town Hall Road, opp. Roadways Bus stand, Civil Lines, Bijnor",
    "phone": "+91 9012548090",
    "whatsappUrl": "https://wa.me/919012548090?text=Hello%2C%20I%20just%20completed%20my%20AI%20Skin%20Analysis%20and%20would%20like%20to%20consult%20with%20your%20dermatologist.",
    "mapsUrl": "https://maps.app.goo.gl/3oDGHbPzHCK2F9Kb8",
    "photoUrl": "/assets/doctors/twacha/photo.jpg",
    "logoUrl": "/assets/doctors/twacha/logo.png",
    "accentColor": "#006437",
    "accentColorDark": "#004E2A",
    "accentColorLight": "#388663"
  },
  {
    "slug": "dhirajchintawar",
    "name": "Dr. Dhiraj Chintawar",
    "clinic": "My Skin Clinic",
    "address": "Shinde Plots, near Shivaji Garden, Shivaji Nagar, Yavatmal",
    "phone": "+91 9405162202",
    "whatsappUrl": "https://wa.me/919405162202?text=Hello%2C%20I%20just%20completed%20my%20AI%20Skin%20Analysis%20and%20would%20like%20to%20consult%20with%20your%20dermatologist.",
    "mapsUrl": "https://maps.app.goo.gl/CyMQwokwe9y3G6FFA",
    "photoUrl": "/assets/doctors/dhirajchintawar/photo.jpg",
    "logoUrl": "/assets/doctors/dhirajchintawar/logo.jpeg",
    "photoObjectPosition": "center 20%",
    "photoZoom": 1.08,
    "accentColor": "#B33037",
    "accentColorDark": "#8B252A",
    "accentColorLight": "#C35D63"
  },
  {
    "slug": "alok",
    "name": "Dr. Dipak Kulkarani",
    "clinic": "Alok Clinic",
    "address": "New Panvel (E), Navi Mumbai, Maharashtra 410206",
    "phone": "+91 7021821758",
    "whatsappUrl": "https://wa.me/917021821758?text=Hello%2C%20I%20just%20completed%20my%20AI%20Skin%20Analysis%20and%20would%20like%20to%20consult%20with%20your%20dermatologist.",
    "mapsUrl": "https://maps.app.goo.gl/FoY2fHMTPYQ9cR7W8",
    "photoUrl": "/assets/doctors/alok/photo.jpg",
    "logoUrl": "/assets/doctors/alok/logo.png",
    "photoObjectPosition": "center 34%",
    "photoZoom": 1.08,
    "accentColor": "#A3C7A5",
    "accentColorDark": "#7F9B80",
    "accentColorLight": "#B7D3B8"
  },
  {
    "slug": "mahani",
    "name": "Dr. Bhumika S",
    "clinic": "Mahani Skin Clinic",
    "address": "Narayanapura, Bengaluru, Karnataka 560077",
    "phone": "+91 9606407797",
    "whatsappUrl": "https://wa.me/919606407797?text=Hello%2C%20I%20just%20completed%20my%20AI%20Skin%20Analysis%20and%20would%20like%20to%20consult%20with%20your%20dermatologist",
    "mapsUrl": "https://maps.app.goo.gl/uWG5WnLpc7QE2Ydj9",
    "photoUrl": "/assets/doctors/mahani/photo.jpeg",
    "logoUrl": "/assets/doctors/mahani/logo.png",
    "accentColor": "#17B2CE",
    "accentColorDark": "#118AA0",
    "accentColorLight": "#4AC2D8"
  },
  {
    "slug": "bharatsinghania",
    "name": "Dr. Bharat Singhania",
    "clinic": "Singhania skin Clinic",
    "address": "Singhania Skin Clinic, Ravinagar Rajatalab, Anand Nagar - Pandri Link Rd, near Rani Sati Mandir, Raipur",
    "phone": "+91 9827000035",
    "whatsappUrl": "https://wa.me/919827000035?text=Hello%2C%20I%20just%20completed%20my%20AI%20Skin%20Analysis%20and%20would%20like%20to%20consult%20with%20your%20dermatologist.",
    "mapsUrl": "https://maps.app.goo.gl/vunzsK4z2cPQcSYW9",
    "photoUrl": "/assets/doctors/bharatsinghania/photo.jpg",
    "logoUrl": "/assets/doctors/bharatsinghania/logo.svg",
    "accentColor": "#E1A730",
    "accentColorDark": "#AF8225",
    "accentColorLight": "#E7BA5D"
  },
  {
    "slug": "atulkathed",
    "name": "Dr. Atul Kathed",
    "clinic": "Dr. Atul Kathed",
    "address": "PVJQ+C76, A-7 MIG, AB Rd, behind axis bank, near sanjeevni nursing home, Phadnis Colony, Indore",
    "phone": "+91 9826014164",
    "whatsappUrl": "https://wa.me/919826014164?text=Hello%2C%20I%20just%20completed%20my%20AI%20Skin%20Analysis%20and%20would%20like%20to%20consult%20with%20your%20dermatologist.",
    "mapsUrl": "https://maps.app.goo.gl/hVCtJaDTHQLNtmnQ8",
    "photoUrl": "/assets/doctors/atulkathed/photo.jpg",
    "logoUrl": "/assets/doctors/atulkathed/logo.png",
    "photoObjectPosition": "center top",
    "accentColor": "#C67499",
    "accentColorDark": "#9A5A77",
    "accentColorLight": "#D292AF"
  },
  {
    "slug": "corium",
    "name": "Dr. Asra Khumushi",
    "clinic": "Corium Skin Clinic",
    "address": "Byramji Town, Nagpur, Maharashtra 440030",
    "phone": "+91 9370000000",
    "whatsappUrl": "https://wa.me/919370275049?text=Hello%2C%20I%20just%20completed%20my%20AI%20Skin%20Analysis%20and%20would%20like%20to%20consult%20with%20your%20dermatologist.",
    "mapsUrl": "https://maps.app.goo.gl/UR38YJng9ixASVH16",
    "photoUrl": "/assets/doctors/corium/photo.jpg",
    "logoUrl": "/assets/doctors/corium/logo.png",
    "photoObjectPosition": "center 26%",
    "photoZoom": 1.22,
    "accentColor": "#EFEEE8",
    "accentColorDark": "#BAB9B4",
    "accentColorLight": "#F2F1ED"
  },
  {
    "slug": "arthkoshiya",
    "name": "Dr. Arth Koshia",
    "clinic": "",
    "address": "Ambawadi, Ahmedabad, Gujarat 380015",
    "phone": "+91 9624200222",
    "whatsappUrl": "https://wa.me/919624200222?text=Hello%2C%20I%20just%20completed%20my%20AI%20Skin%20Analysis%20and%20would%20like%20to%20consult%20with%20your%20dermatologist.",
    "mapsUrl": "https://maps.app.goo.gl/wUgzBZYjzQ21Ns6f6",
    "photoUrl": "/assets/doctors/arthkoshiya/photo.jpeg",
    "logoUrl": "/assets/doctors/arthkoshiya/logo.svg",
    "accentColor": "#D7B56D",
    "accentColorDark": "#A78D55",
    "accentColorLight": "#DFC58D"
  },
  {
    "slug": "mayang",
    "name": "Dr. Anil Kumar Soni",
    "clinic": "Mayang Skin Care",
    "address": "chitragupt mandir road, Naya Chowk, Japlin Ganj, Ballia",
    "phone": "+91 9559896070",
    "whatsappUrl": "https://wa.me/919559896070?text=Hello%2C%20I%20just%20completed%20my%20AI%20Skin%20Analysis%20and%20would%20like%20to%20consult%20with%20your%20dermatologist.",
    "mapsUrl": "https://maps.app.goo.gl/3YiJRLSj4zHBc7Kr9",
    "photoUrl": "/assets/doctors/mayang/photo.jpg",
    "logoUrl": "/assets/doctors/mayang/logo.png",
    "accentColor": "#FF87BF",
    "accentColorDark": "#C66994",
    "accentColorLight": "#FFA1CD"
  },
  {
    "slug": "aminhanan",
    "name": "Dr. Amin Hanan",
    "clinic": "Dr. Hanan Dermatology Speciality Clinic",
    "address": "Padur, Chennai, Tamil Nadu 603103",
    "phone": "+91 6381000000",
    "whatsappUrl": "https://wa.me/916381048403?text=Hello%2C%20I%20just%20completed%20my%20AI%20Skin%20Analysis%20and%20would%20like%20to%20consult%20with%20your%20dermatologist.",
    "mapsUrl": "https://maps.app.goo.gl/vZJEBG4XKG2QKfY87",
    "photoUrl": "/assets/doctors/aminhanan/photo.jpg",
    "logoUrl": "/assets/doctors/aminhanan/logo.png",
    "accentColor": "#503B1E",
    "accentColorDark": "#3E2E17",
    "accentColorLight": "#76664F"
  },
  {
    "slug": "kosme",
    "name": "Dr. Alok Sultania",
    "clinic": "The kosme care",
    "address": "infront of subhash complex, Rajiv Gandhi Chowk, Govind Nagar, Jarahbhata, Bilaspur",
    "phone": "+91 7752401919",
    "whatsappUrl": "https://wa.me/919977873208?text=Hello%2C%20I%20just%20completed%20my%20AI%20Skin%20Analysis%20and%20would%20like%20to%20consult%20with%20your%20dermatologist.",
    "mapsUrl": "https://maps.app.goo.gl/mmyRUfMoMCMfyYPN8",
    "photoUrl": "/assets/doctors/kosme/photo.jpg",
    "logoUrl": "/assets/doctors/kosme/logo.svg",
    "photoObjectPosition": "100% center",
    "photoZoom": 1.12,
    "accentColor": "#C7D30A",
    "accentColorDark": "#9BA407",
    "accentColorLight": "#D3DC3F"
  },
  {
    "slug": "indra",
    "name": "Dr. Ajay Kumar Rai",
    "clinic": "Indra Skin Clinic",
    "address": "1st Floor, C-115 Sector M, Aliganj, near PNB Road, Mama Chauraha, Vikas Nagar, Lucknow",
    "phone": "+91 9519262342",
    "whatsappUrl": "https://wa.me/919519262342?text=Hello%2C%20I%20just%20completed%20my%20AI%20Skin%20Analysis%20and%20would%20like%20to%20consult%20with%20your%20dermatologist.",
    "mapsUrl": "https://maps.app.goo.gl/VPvGSbpHHsVAYeX89",
    "photoUrl": "/assets/doctors/indra/photo.jpg",
    "logoUrl": "/assets/doctors/indra/logo.png",
    "accentColor": "#D0D25E",
    "accentColorDark": "#A2A349",
    "accentColorLight": "#DADB81"
  },
  {
    "slug": "kaayakulp",
    "name": "Dr. V.S. Rathore",
    "clinic": "Kaaya Kulp clinic",
    "address": "P-158, 2nd floor, CIT Rd, Scheme VI-M, Kankurgachi, Kolkata, West Bengal 700054",
    "phone": "+91 98316 62311",
    "whatsappUrl": "https://wa.me/919831662311?text=Hello%2C%20I%20just%20completed%20my%20AI%20Skin%20Analysis%20and%20would%20like%20to%20consult%20with%20your%20dermatologist",
    "mapsUrl": "https://maps.app.goo.gl/Ur6ab4ZkJi6AsCrX7",
    "photoUrl": "/assets/doctors/kaayakulp/photo.jpg",
    "logoUrl": "/assets/doctors/kaayakulp/logo.png",
    "accentColor": "#D3CEA8",
    "accentColorDark": "#A4A083",
    "accentColorLight": "#DCD8BB"
  },
  {
    "slug": "almeka",
    "name": "Dr. Celia Mathew",
    "clinic": "Almeka Medical Centre",
    "address": "1st Floor, Ravi Tower, Vennala P O, NH Bypass, Palarivattom, Kochi, Kerala 682028",
    "phone": "+91 95262 04090",
    "whatsappUrl": "https://wa.me/919847024090?text=Hello%2C%20I%20just%20completed%20my%20AI%20Skin%20Analysis%20and%20would%20like%20to%20consult%20with%20your%20dermatologist",
    "mapsUrl": "https://maps.app.goo.gl/tPBAQLePUP7LmvcVA",
    "photoUrl": "/assets/doctors/almeka/photo.jpg",
    "logoUrl": "/assets/doctors/almeka/logo.svg",
    "photoObjectPosition": "center 20%",
    "photoZoom": 1.12,
    "accentColor": "#A72957",
    "accentColorDark": "#821F43",
    "accentColorLight": "#BA587B"
  },
  {
    "slug": "premier",
    "name": "Dr. Mohammed Naseef",
    "clinic": "Premier skin care center",
    "address": "1st floor, Shola Complex, University Rd, above federal bank, Ramanattukara, Kozhikode, Kerala 673631",
    "phone": "+91 96331 54254",
    "whatsappUrl": "https://wa.me/919633154254?text=Hello%2C%20I%20just%20completed%20my%20AI%20Skin%20Analysis%20and%20would%20like%20to%20consult%20with%20your%20dermatologist",
    "mapsUrl": "https://maps.app.goo.gl/EaLD8ExexdmUt127A",
    "photoUrl": "/assets/doctors/premier/photo.jpg",
    "logoUrl": "/assets/doctors/premier/logo.png",
    "accentColor": "#9B7963",
    "accentColorDark": "#785E4D",
    "accentColorLight": "#B19685"
  },
  {
    "slug": "serene",
    "name": "Dr. Sonia Feroz",
    "clinic": "Serene Derma",
    "address": "Vellayambalam - Vazhuthacaud Road, VRaman road, opposite Trivandrum club C, Thiruvananthapuram, Kerala 695010",
    "phone": "+91 90481 03091",
    "whatsappUrl": "https://wa.me/919048103091?text=Hello%2C%20I%20just%20completed%20my%20AI%20Skin%20Analysis%20and%20would%20like%20to%20consult%20with%20your%20dermatologist",
    "mapsUrl": "https://maps.app.goo.gl/e4w7cfmXVV6FJfEu8",
    "photoUrl": "/assets/doctors/serene/photo.jpg",
    "logoUrl": "/assets/doctors/serene/logo.png",
    "photoObjectPosition": "45% top",
    "photoZoom": 1.05,
    "accentColor": "#A47545",
    "accentColorDark": "#7F5B35",
    "accentColorLight": "#B8936D"
  },
  {
    "slug": "mohta",
    "name": "Dr. Isha Mohta",
    "clinic": "Mohta Skin Clinic",
    "address": "Tilak Maidan, Main Rd, behind Madhuban Saree, Lakkad Ganj, Khamgaon, Maharashtra 444303",
    "phone": "+91 98344 38003",
    "whatsappUrl": "https://wa.me/919834438003?text=Hello%2C%20I%20just%20completed%20my%20AI%20Skin%20Analysis%20and%20would%20like%20to%20consult%20with%20your%20dermatologist",
    "mapsUrl": "https://maps.app.goo.gl/8Yf6HznPmoQ2d5z68",
    "photoUrl": "/assets/doctors/mohta/photo.jpeg",
    "logoUrl": "/assets/doctors/mohta/logo.jpeg",
    "accentColor": "#013147",
    "accentColorDark": "#002637",
    "accentColorLight": "#385E6F"
  },
  {
    "slug": "mayavedamurthy",
    "name": "Dr. Maya Vedamurthy",
    "clinic": "Dr. Maya Vedamurthy's skin clinic",
    "address": "9/5, Mahalingam 2nd Cross St, Mahalingapuram, Nungambakkam, Chennai, Tamil Nadu 600006",
    "phone": "+91 97909 43345",
    "whatsappUrl": "https://wa.me/919790943345?text=Hello%2C%20I%20just%20completed%20my%20AI%20Skin%20Analysis%20and%20would%20like%20to%20consult%20with%20your%20dermatologist",
    "mapsUrl": "https://maps.app.goo.gl/fSDRdAvzyMJBgUjF9",
    "photoUrl": "/assets/doctors/mayavedamurthy/photo.jpg",
    "logoUrl": "/assets/doctors/mayavedamurthy/logo.svg",
    "photoObjectPosition": "75% center",
    "accentColor": "#D12023",
    "accentColorDark": "#A3181B",
    "accentColorLight": "#DB5153"
  },
  {
    "slug": "nadhiracosmo",
    "name": "Dr. Syed Nazeer",
    "clinic": "Nadhira Cosmo Clinic",
    "address": "First floor, Check post, 46, Chennai - Tiruvallur High Rd, Gandhi Nagar, Avadi, Tamil Nadu 600054",
    "phone": "+91 90807 55402",
    "whatsappUrl": "https://wa.me/919080755402?text=Hello%2C%20I%20just%20completed%20my%20AI%20Skin%20Analysis%20and%20would%20like%20to%20consult%20with%20your%20dermatologist",
    "mapsUrl": "https://maps.app.goo.gl/BvMFPLgjRq7NNboC8",
    "photoUrl": "/assets/doctors/nadhiracosmo/photo.jpg",
    "logoUrl": "/assets/doctors/nadhiracosmo/logo.png",
    "accentColor": "#9C824B",
    "accentColorDark": "#79653A",
    "accentColorLight": "#B19D72"
  },
  {
    "slug": "nuskin",
    "name": "Dr. Geetika Ahuja",
    "clinic": "NuSkin Advanced Derma Centre",
    "address": "Clinic, Road, inside Mittal Health Care, Haripura, Punia Colony, Sangrur, Punjab 148001",
    "phone": "+91 8264355900",
    "whatsappUrl": "https://wa.me/918264355900?text=Hello%2C%20I%20just%20completed%20my%20AI%20Skin%20Analysis%20and%20would%20like%20to%20consult%20with%20your%20dermatologist",
    "mapsUrl": "https://maps.app.goo.gl/K8ooUKamF7co2t4Q7",
    "photoUrl": "/assets/doctors/nuskin/photo.jpg",
    "logoUrl": "/assets/doctors/nuskin/logo.svg",
    "photoObjectPosition": "center top",
    "photoZoom": 1,
    "accentColor": "#D7B56D",
    "accentColorDark": "#A78D55",
    "accentColorLight": "#DFC58D"
  }
];

const DEFAULT_ROUTINE_THEME = {
  card: 'bg-gradient-to-r from-slate-50 to-gray-50',
  iconBg: 'bg-gray-100',
  iconText: 'text-gray-600',
  titleText: 'text-gray-900',
  bodyText: 'text-gray-700'
};

function getInitials(name) {
  const parts = String(name || '')
    .replace(/^dr\.?\s+/i, '')
    .split(/\s+/)
    .filter(Boolean);

  if (parts.length === 0) return 'DR';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
}

function createBatchDoctorConfig(doctor) {
  const accent = doctor.accentColor;
  const accentDark = doctor.accentColorDark || doctor.accentColor;
  const accentLight = doctor.accentColorLight || doctor.accentColor;

  return {
    name: doctor.name,
    clinic: doctor.clinic,
    address: doctor.address,
    phone: doctor.phone,
    whatsappUrl: doctor.whatsappUrl,
    bookingUrl: null,
    mapsUrl: doctor.mapsUrl,
    photoUrl: doctor.photoUrl,
    logoUrl: doctor.logoUrl,
    logoAlt: doctor.clinic,
    slug: doctor.slug,
    initials: getInitials(doctor.name),
    branches: null,
    welcomeStyle: 'split-pane',
    photoSize: 'medium',
    photoBorderClass: 'border-4',
    photoObjectClass: '',
    photoObjectPosition: doctor.photoObjectPosition || undefined,
    photoZoom: doctor.photoZoom || undefined,
    photoTransformOrigin: doctor.photoTransformOrigin || undefined,
    analysisWaitingLogoClass: doctor.analysisWaitingLogoClass || undefined,
    accentColor: accent,
    accentColorDark: accentDark,
    leftPaneSubtitleColor: 'text-white/80',
    rightPaneBg: 'bg-white',
    clinicNameColor: 'text-gray-900',
    fetchedImageBorder: 'border-gray-200',
    fetchedImageFallbackFrom: accent,
    fetchedImageFallbackTo: accentDark,
    fetchedImageFallbackIcon: accentLight,
    featureCardIconBg: 'bg-gray-100',
    contactLinkText: 'text-gray-700',
    contactLinkBg: 'bg-gray-50',
    contactLinkBorder: 'border-gray-200',
    contactType: 'whatsapp',
    analysisAccent: accent,
    analysisAccentDark: accentDark,
    analysisAccentLight: accentLight,
    analysisTimerColor: accent,
    analysisScanGradient: false,
    analysisProgressGradient: false,
    routineTheme: DEFAULT_ROUTINE_THEME,
    analysisDisclaimerFallback: `This AI analysis is for informational purposes only. Please consult with ${doctor.name} at ${doctor.clinic} (${doctor.phone}) for professional diagnosis and treatment recommendations.`,
    analysisConsultFallback: `Consult with ${doctor.name} for personalized recommendations.`,
    pdfAccent: accent,
    pdfAccentDark: accentDark,
    pdfAccentLight: accentLight,
    reportIdPrefix: 'SKN',
    footerName: doctor.name,
    footerExtra: null,
    pdfContactExtraLine: null,
    followUpColors: { bg: '#F8FAFC', border: accent, text: accentDark },
    contactSectionBg: 'primary',
    keyConcernsBadge: { bg: '#F8FAFC', color: accentDark },
    pdfClinicName: doctor.clinic,
    pdfPhone: doctor.phone,
    pdfAddress: doctor.address,
    pdfDisclaimer: `This AI-powered skin analysis is for informational purposes only. Please consult ${doctor.name} for professional diagnosis and treatment.`
  };
}

const BATCH_DOCTOR_CONFIGS = Object.fromEntries(
  BATCH_DOCTOR_DATA.map((doctor) => [doctor.slug, createBatchDoctorConfig(doctor)])
);

export { BATCH_DOCTOR_DATA };
export default BATCH_DOCTOR_CONFIGS;
